import { Spacing, Title } from '@vkontakte/vkui';
import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { getAiPhotoGenerationTime } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.helpers';
import { useAiPhotoGenerationAnalyticData } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.hooks';
import {
    getAiGenerationImageLoaderTextVariant,
    getAiGenerationImagePercentage,
    getAiGenerationStartTime,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.selectors';
import { openAiPhotoGenerationCancelGenerationModal } from 'reactApp/ui/AiPhotoGeneration/Modals/CancelGeneration/AiPhotoGenerationCancelGenerationModal.helpers';
import { Button, ButtonVariant } from 'reactApp/ui/Button/Button';
import LottieFetch from 'reactApp/ui/Lottie/LottieFetch';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AiPhotoGenerationLoader.css';
import { AiPhotoGenerationLoaderText } from './AiPhotoGenerationLoaderText';

const animationSrc = `${cdnPackagesUrl}/static/cloud/ai/photo-generation/loader/loader.json`;

export const AiPhotoGenerationLoader = memo(function FullScreenAiPhotoGenerationLoader() {
    const percentage = useSelector(getAiGenerationImagePercentage);
    const text = useSelector(getAiGenerationImageLoaderTextVariant);
    const startTime = useSelector(getAiGenerationStartTime);
    const analyticData = useAiPhotoGenerationAnalyticData();

    const handleCancel = useCallback(() => {
        openAiPhotoGenerationCancelGenerationModal();

        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'cancel-btn-click',
            ...analyticData,
            generation_time: getAiPhotoGenerationTime(startTime),
            dwh_enabled: true,
            dwh_enabled_fields: [['paid_user', 'corp_user', 'style']],
        });
    }, [analyticData, startTime]);

    return (
        <>
            <LottieFetch src={animationSrc} loop={true} autoplay={true} className={styles.lottie} />
            <div className={styles.container}>
                <Title className={styles.percentage}>{percentage}%</Title>
                <Spacing size={24} />
                <Title className={styles.title}>
                    <AiPhotoGenerationLoaderText text={text} />
                </Title>
                <Spacing size={8} />
                <span className={styles.text}>Изображение генерируется</span>
                <Spacing size={96} />
                <Button onClick={handleCancel} className={styles.button} size="medium" variant={ButtonVariant.contrast}>
                    Остановить генерацию
                </Button>
            </div>
        </>
    );
});
